/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import AdminTable from '../../../components/AdminTable';
import DashboardHeader from '../../../components/DashboardHeader';
import EmptyRecord from '../../../components/EmptyRecord';
import { useGlobalState } from '../../../contexts';
// import useFilterMethods from '../../../customHooks/useFilterMethods';
import useGetQueryParams from '../../../customHooks/useGetQueryParams';
import useTableColumn from '../../../customHooks/useTableColumn';
// import useToast from '../../../customHooks/useToast';
import { GET_ALL_STAFF } from '../../../graphql/admin_queries';
import useCustomQuery from '../../../network/useCustomQuery';
import EmptyAdminCuatomerIcon from '../../../svgs/EmptyAdminCuatomerIcon';
import ListIcon from '../../../svgs/ListIcon';
import PlusIcon from '../../../svgs/PlusIcon';
// import generateCSV from '../../../utils/generateCSV';
// import generatePDF from '../../../utils/generatePdf';
import { adminHasPermission, cleanUpAdminAllStaff } from '../../../utils/helpers';
import Styles from './UserManagement.module.scss';
import ActivateMember from './_partials/ActivateMember';
import DeactivateMember from './_partials/DeactivateMember';
import InviteNewStaff from './_partials/InviteMember';

// import { useGlobalState } from '../../contexts/AdminGlobalContext';

// import { loadpayfiProduct } from '../../contexts/AdminGlobalContext';

const limit = 14;
interface IUserManagement{
  defaultUrl?:any;
  toggleStorageId?:string;
  hasNameAndImage:any;
}

const UserManagement = ({ toggleStorageId, hasNameAndImage }:IUserManagement) => {
  const { profile }:any = useGlobalState();
  const adminPermissions = profile?.role?.permissions || [];
  // const Toast = useToast();
  const [getStaffRecord, getStaffLoading, staffData] = useCustomQuery({
    query: GET_ALL_STAFF,
    onError: () => {},
    onData: () => {},
  });

  const { getQuery, getFilterQueries } = useGetQueryParams();
  const search = getQuery('search') || '';
  const page = Number(getQuery('page'));
  const { push } = useHistory();
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [showActivateModal, setShowActivateModal] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);

  const allColumns = [
    ['image', 'email', 'hasBottomValue', 'name'],
    'phone',
    'department',
    'role',
    'status',
  ];
  const columnLabelFormat = {
    name: 'Name',
    phone: 'Phone Number',
    department: 'Department',
    role: 'Role',
    status: 'Status',
    // image__name: 'Name',
  };
  const { getColumns, applyChanges, selectedColumns } = useTableColumn(allColumns, toggleStorageId);

  const [staffRec, setStaffRec] = useState(null);

  const setPage = (pageNum) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page', pageNum);
    push({
      search: searchParams.toString(),
    });
  };
  if (!page) {
    push(`/settings/user-management?page=1&search=${search}`);
  }

  const onSearchChange = (e) => {
    push(`/settings/user-management?page=1&search=${encodeURIComponent(e.target.value)}`);
  };

  const getStaffFunc = async (result, offset, lim = limit) => getStaffRecord({
    variables: {
      limit: lim,
      offset,
      search,
      // statusFilter: result?.status,
      // roleId: null,
    },
  });
  useEffect(() => {
    if (page) {
      const result = getFilterQueries();
      getStaffFunc(result, (page - 1) * limit);
    }
  }, [page, search]);

  // const onFilterSubmit = (result) => {
  //   getStaffFunc(result, 0);
  // };

  // const {
  //   filterObj,
  // } = useFilterMethods({
  //   allowedFilters: ['dateRange', 'status'],
  //   defaultUrl,
  //   cb: onFilterSubmit,
  //   Toast,
  //   customFilterInformation: {
  //     dateRange: {
  //       label: 'Period',
  //     },
  //     status: {
  //       label: 'Status',
  //       options: [
  //         {
  //           label: 'Active',
  //           value: '1',
  //         },
  //         {
  //           label: 'Inactive',
  //           value: '0',
  //         },

  //       ],
  //     },
  //   },
  // });

  useEffect(() => {
    if (staffData?.getStaffs
      ?.data?.rows
    ) {
      setStaffRec(staffData?.getStaffs
        ?.data);
    }
  }, [staffData]);

  // const [getExportRecord] = useCustomQuery({
  //   query: GET_ALL_STAFF,
  //   onError: () => {},
  //   onData: () => {},
  // });

  // const handleExport = async (type: string) => {
  //   try {
  //     const result = getFilterQueries();
  //     const output = await getExportRecord({
  //       variables: {
  //         offset: 0,
  //         limit: 2000,
  //         search,
  //         filters: {
  //           from: result?.from,
  //           to: result?.to,
  //           status: result?.status,
  //         },
  //       },
  //     });
  //     if (output?.data?.usersCa?.users) {
  //       const rec = cleanUpAdminAllStaff(output?.data?.usersCa?.users);
  //       const func = type === 'pdf' ? generatePDF : generateCSV;
  //       const selectedHeaders = [
  //         'S/N',
  //         // change image__email__hasBottomValue__name concated columns to a single column of name
  //         ...(getColumns?.()?.map((column) => (column === 'image__email__hasBottomValue__name' ? ['name', 'email'] : column)) || []),
  //       ];

  //       func({
  //         payload: rec,
  //         title: 'CUSTOMER',
  //         selectedHeaders,
  //         formatHeaders: columnLabelFormat,
  //         cb: () => Toast.success('Exported successfully'),
  //       });
  //     }
  //   } catch (error) {
  //     Toast.error('Error while exporting');
  //   }
  // };

  const handleSelectDropdown = (dropdownTitle, details) => {
    if (dropdownTitle === 'Activate Member') {
      setSelectedMember(details);
      setShowActivateModal(true);
      return;
    }
    if (dropdownTitle === 'Deactivate Member') {
      setSelectedMember(details);
      setShowDeactivateModal(true);
      return;
    }
    push(`/settings/user-management/${details?.id}`);
  };

  return (
    <div className={Styles.wrapper}>
      <DashboardHeader
        title="Customers"
        smallSubTitle={`(${staffRec?.count || 0})`}
        searchPlaceholder="Search by User ID, customer’s name, email address and phone number"
        search={search}
        onSearchChange={onSearchChange}
        searchLoading={getStaffLoading}
        hasContainerClass={Styles.wrapper__searchAndActionsContainer}
        // filterObj={filterObj}
        columnObject={{
          allColumns,
          formatLabels: columnLabelFormat,
          applyChanges,
          selectedColumns,
        }}
        disableSearch={!adminHasPermission(adminPermissions, 'can-search-customers-record')}
        disableExport={!adminHasPermission(adminPermissions, 'can-export-selected-data')}
        disbleFilter={!adminHasPermission(adminPermissions, 'can-filter-customer-record')}
        // exportObj={{
        //   handleExport,
        // }}
        handleButtonAction={() => setShowInviteModal(true)}
        hasButton
        buttonTitle="Invite a Team Member"
        buttonIcon={<PlusIcon />}
      />
      {/* <RolesAndPermissionGuard permissionName={permissionName} hasErrorTemplate={<PermissionDenied height="60vh" />}> */}
      <div className="merchant-table-details-cover">
        {staffRec?.count ? (
          <AdminTable
            refreshing={getStaffLoading}
            page={page}
            setPage={setPage}
            pageSize={limit}
            minHeight="calc(100vh - 280px)"
            count={staffRec?.count}
            contents={cleanUpAdminAllStaff(staffRec?.rows)}
            reference="id"
            hideDominantImage
            clickable
            hasNameAndImage={hasNameAndImage}
            handleDropdown={handleSelectDropdown}
            // handleClick={(data) => {
            //   push(`/customers/customer-details/${data.id}/profile`);
            // }}
            allowKeyArr={getColumns(true)}
            mobileAllowKeyArr={
              [
                'status',
                ['name', 'role'],
                ['phone', 'email'],

              ]
            }
            // actionList
            formatLabels={columnLabelFormat}
            dropdownType="staffs"
            dropDownIcon={<div className={Styles.wrapper__icon}><ListIcon /></div>}
          />
        ) : (
          <EmptyRecord
            height="calc(100vh - 240px)"
            title={getStaffLoading ? 'Fetching staff...' : 'No staff found'}
            main="All staffs and their details will appear here on the dashboard."
            // footer="Receive Payments"
            loading={getStaffLoading}
            Icon={EmptyAdminCuatomerIcon}
          />
        )}

      </div>
      {/* </RolesAndPermissionGuard> */}
      {
        showInviteModal && <InviteNewStaff closeModal={() => setShowInviteModal(false)} refetchData={getStaffFunc} />
      }
      {
        showActivateModal && selectedMember && <ActivateMember payload={selectedMember} onClose={() => setShowActivateModal(false)} refetch={getStaffFunc} />
      }
      {
        showDeactivateModal && selectedMember && <DeactivateMember payload={selectedMember} onClose={() => setShowDeactivateModal(false)} refetch={getStaffFunc} />
      }

    </div>
  );
};
export default UserManagement;
